export default __webpack_public_path__ + "static/media/successicon.edceea88.svg";